import { c as _c } from "react/compiler-runtime";
import { DocumentWhite } from "@/lib/icons";
import type { Cat } from "@/types/movies";
import Link from "next/link";
interface Props {
  rating?: string;
  seasons?: string;
  year?: string;
  countries?: Cat[];
  subtitles?: string;
  ageLimit?: string;
}
export default function MovieMeta(props) {
  const $ = _c(23);
  let t0;
  if ($[0] !== props.rating) {
    t0 = props.rating && <div className="flex items-center justify-center"><span className="sm:text-sm md:text-md font-extrabold text-imdb me-1 md:me-2">IMDB</span> <span className="sm:text-sm md:text-md font-extrabold text-white">{props.rating}</span></div>;
    $[0] = props.rating;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.seasons) {
    t1 = <span className="sm:text-sm md:text-md text-white">{props.seasons}</span>;
    $[2] = props.seasons;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== props.year) {
    t2 = <span className="sm:text-sm md:text-md text-white font-extrabold me-1 md:me-2">{props.year}</span>;
    $[4] = props.year;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props.countries) {
    t3 = props.countries ?? [];
    $[6] = props.countries;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = t3.map(_temp);
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t2 || $[11] !== t4) {
    t5 = <div className="flex items-center justify-center">{t2}{t4}</div>;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== props.subtitles) {
    t6 = props?.subtitles && <div className="flex items-center justify-center"><DocumentWhite /><span className="sm:text-sm md:text-md text-white font-extrabold ms-1 md:ms-2 mt-0">{props.subtitles}</span></div>;
    $[13] = props.subtitles;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== props.ageLimit) {
    t7 = props.ageLimit && <span className="sm:text-sm md:text-md text-white font-extrabold">{props.ageLimit}</span>;
    $[15] = props.ageLimit;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t0 || $[18] !== t1 || $[19] !== t5 || $[20] !== t6 || $[21] !== t7) {
    t8 = <div className="mt-4 flex flex-wrap items-center gap-x-2 md:gap-x-5 gap-y-2 text-xs sm:text-sm sm:mb-4 md:mb-6">{t0}{t1}{t5}{t6}{t7}</div>;
    $[17] = t0;
    $[18] = t1;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
}
function _temp(n, idx, arr) {
  const isLast = idx === arr.length - 1;
  return <Link key={idx} href={`/movie/tags/${n.name_en}`} className="sm:text-sm md:text-md text-white">{n.name_fa}{!isLast && <span className="mx-1">،</span>}</Link>;
}